import React from "react";
import "./Common_Banner_2.css";
import Breadcrumb_comp from "../breadcrumb-comp/Breadcrumb_comp";

const Common_Banner_2 = ({ imgSrc, title_text, breadcrumbs = [] }) => {
  return (
    <section className="Common_Banner_2">
      <div className="img_holder">
        <img src={imgSrc} className="banner_img" />
      </div>

      <div className="container ">
        <div className="content_div">
          <p className="title_text">{title_text}</p>

          <div className="breadcrump_div">
            <Breadcrumb_comp breadcrumbs={breadcrumbs} />
          </div>
        </div>
      </div>

      <div className="overlay_colour"></div>
    </section>
  );
};

export default Common_Banner_2;
